import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {IFilter} from "../../services/IFilter";

export class SaAccessCategoryFilter implements IFilter {

  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(name:any) {
    this.nameChange.next(name);
    this.emitChange("name", name);
  }

  shortCodeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get shortCode():any {
    return this.shortCodeChange.value;
  }
  set shortCode(shortCode:any) {
    this.shortCodeChange.next(shortCode);
    this.emitChange("shortCode", shortCode);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(description:any) {
    this.descriptionChange.next(description);
    this.emitChange("description", description);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }

    if (this.shortCode && this.shortCode !== '') {
      params = params.set("shortCode", this.shortCode);
    }

    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }

    return params;
  }

  setFilters(props: any): void {
    this.nameChange.next(props.name || undefined);
    this.shortCodeChange.next(props.shortCode || undefined);
    this.descriptionChange.next(props.description || undefined);
  }

  toObj() {
    let obj:any = {
      name: this.name,
      shortCode: this.shortCode,
      description: this.description,
    };
    return obj;
  }

  public clear():void {
    this.name = undefined;
    this.shortCode = undefined;
    this.description = undefined;
  }
}
